import { render, staticRenderFns } from "./listaJuzgados.vue?vue&type=template&id=f1bd1b7a"
import script from "./listaJuzgados.vue?vue&type=script&lang=js"
export * from "./listaJuzgados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports